const FULL_LOGGED_OUT_PAGE_SIZE = 57;

export const useLoggedOutCategoryPageRequestPageSize = () => {
  return FULL_LOGGED_OUT_PAGE_SIZE;
};
